export default class formConfig {
  // 招标计划
  static configList() {
    return [
      {
        title: "流程信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "流程名称：",
            value: "stepName",
            type: "input",
            required: true,
            maxlength: 50,
            rule: {
              required: true,
              message: "请输入流程名称",
              trigger: "blur"
            }
          },
          {
            label: "流程编码：",
            type: "input",
            value: "pathName",
            maxlength: 50,
            required: true,
            rule: {
              required: true,
              message: "请输入流程编码",
              trigger: "blur"
            }
          },
          {
            label: "所属区管：",
            type: "select",
            value: "region",
            placeholder: "请选择",
            queryParams: {
              url: "/auditDepartment/auditDepartmentCombobox",
              pid: "0"
            },
            rule: {
              required: true,
              message: "请选择所属区管",
              trigger: "change"
            }
          }
        ]
      },
      {
        title: "流程步骤",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            slotName: "nodeList",
            class: "table formList"
          }
        ]
      }
    ];
  }
}
